import type { Dispatch } from '@reduxjs/toolkit';
import { createMmWsAction } from '@skynet/data-ws-mm';

/**
 * Payload of the MM admin channel `Listen`. One command serves three Admin
 * views: `servers` streams server statuses, `log` the Admin log, `admin` the
 * domain.
 */
export interface AdminListenPayload {
  section: 'servers' | 'log' | 'admin';
  /** Accounts whose details the Servers page has open (from its URL). */
  accountsID?: string[];
}

/**
 * The admin channel `Listen` (`admin/listen`), sent through the MM channel.
 * Pass `{ isInitCall: true }` as meta on the first send of a view and
 * `{ isInitCall: false }` on its keep-alive pings; reducers key their loading
 * flags on it.
 */
export const adminListen = createMmWsAction<AdminListenPayload, AdminListenPayload>(
  'admin/listen',
  (data) => ({ command: 'Listen', ...data }),
);

/** A dispatch narrowed to {@link adminListen}; the app's root dispatch satisfies it. */
export type AdminListenDispatch = Dispatch<ReturnType<typeof adminListen>>;
